import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import MiscUtils from 'mewe/utils/miscellaneous-utils';
import { formatUTCDateToCustomString } from 'mewe/utils/datetime-utils';
import { getConfigCatFlagPromise } from 'mewe/shared/config-cat';
import { isPresent } from '@ember/utils';
import WalletApi from 'mewe/api/wallet-api';
import { loadMoonPay } from '@moonpay/moonpay-js';
import { later } from '@ember/runloop';

const transactions = [
  { id: 1, date: '2025-09-04T14:23:00Z', transactionChange: '+', name: 'Alice', value: 5000, currencyType: 'USD' },
  { id: 2, date: '2025-08-28T09:15:00Z', transactionChange: '-', name: 'Bob', value: 120, currencyType: 'Soshi' },
  { id: 3, date: '2025-08-15T18:45:00Z', transactionChange: '+', name: 'Charlie', value: 800, currencyType: 'BTC' },
  { id: 4, date: '2025-08-10T07:30:00Z', transactionChange: '-', name: 'Diana', value: 1500, currencyType: 'USD' },
  { id: 5, date: '2025-07-30T21:10:00Z', transactionChange: '-', name: 'Eve', value: 200, currencyType: 'USD' },
  { id: 6, date: '2025-07-20T11:55:00Z', transactionChange: '+', name: 'Frank', value: 100, currencyType: 'ETH' },
  { id: 7, date: '2025-07-10T16:40:00Z', transactionChange: '-', name: 'Grace', value: 75, currencyType: 'USD' },
  { id: 8, date: '2025-06-25T08:20:00Z', transactionChange: '+', name: 'Hank', value: 300, currencyType: 'ADA' },
  { id: 9, date: '2025-06-15T13:05:00Z', transactionChange: '-', name: 'Ivy', value: 50, currencyType: 'USD' },
  { id: 10, date: '2025-06-01T19:50:00Z', transactionChange: '-', name: 'Jack', value: 15, currencyType: 'USD' },
  { id: 11, date: '2025-05-20T10:35:00Z', transactionChange: '+', name: 'Kate', value: 60, currencyType: 'POL' },
  { id: 12, date: '2025-05-10T15:20:00Z', transactionChange: '-', name: 'Leo', value: 250, currencyType: 'BTC' },
  { id: 13, date: '2025-04-30T06:05:00Z', transactionChange: '+', name: 'Mona', value: 20, currencyType: 'BTC' },
  { id: 14, date: '2025-04-15T12:50:00Z', transactionChange: '-', name: 'Nate', value: 100, currencyType: 'ETH' },
  { id: 15, date: '2025-03-28T17:35:00Z', transactionChange: '+', name: 'Olivia', value: 40, currencyType: 'USD' },
  { id: 16, date: '2025-03-10T22:20:00Z', transactionChange: '-', name: 'Paul', value: 80, currencyType: 'ADA' },
  { id: 17, date: '2025-02-25T09:05:00Z', transactionChange: '+', name: 'Quinn', value: 30, currencyType: 'USD' },
  { id: 18, date: '2025-02-10T14:50:00Z', transactionChange: '-', name: 'Rita', value: 400, currencyType: 'SOL' },
  { id: 19, date: '2025-01-30T20:35:00Z', transactionChange: '+', name: 'Sam', value: 70, currencyType: 'USD' },
  { id: 20, date: '2025-01-10T11:20:00Z', transactionChange: '-', name: 'Tina', value: 300, currencyType: 'SOL' },
  { id: 21, date: '2024-12-25T16:05:00Z', transactionChange: '+', name: 'Uma', value: 150, currencyType: 'USD' },
  { id: 22, date: '2024-12-10T07:50:00Z', transactionChange: '-', name: 'Vince', value: 60, currencyType: 'Soshi' },
  { id: 23, date: '2024-11-30T13:35:00Z', transactionChange: '+', name: 'Wendy', value: 90, currencyType: 'USD' },
  { id: 24, date: '2024-11-15T18:20:00Z', transactionChange: '-', name: 'Xander', value: 110, currencyType: 'Soshi' },
  { id: 25, date: '2024-10-30T23:05:00Z', transactionChange: '+', name: 'Yara', value: 200, currencyType: 'USD' },
  { id: 26, date: '2024-10-10T09:50:00Z', transactionChange: '-', name: 'Zack', value: 500, currencyType: 'Soshi' },
  { id: 27, date: '2024-09-25T15:35:00Z', transactionChange: '+', name: 'Bella', value: 1000, currencyType: 'Soshi' },
  { id: 28, date: '2024-09-10T20:20:00Z', transactionChange: '-', name: 'Cody', value: 60, currencyType: 'USD' },
  { id: 29, date: '2024-08-30T11:05:00Z', transactionChange: '+', name: 'Derek', value: 25, currencyType: 'USD' },
  { id: 30, date: '2024-08-10T16:50:00Z', transactionChange: '-', name: 'Ella', value: 10, currencyType: 'USD' }
];

const nfts = [
  { id: 1, name: 'NFT 1', image: '/img-proxy/api/v2/photo/fHodvsoE7B4eNpUIjZqO2aNHjmD3dCOUxtRqu5_yz8Bo6RS63ldWZRLkFyM/800x800/img?static=0' },
  { id: 2, name: 'NFT 2', image: '/img-proxy/api/v2/photo/zdSlpR7irL499aKYqFnEB2THevXhC6-zKBQNpWpTGW1oynKiVSKXOpka0bI/1600x1600/img?static={static}' },
  { id: 3, name: 'NFT 3', image: '/img-proxy/api/v2/photo/OIkzum2U43vNy8NQa4Qd2nnvkqnS-woqNGVaWphGWgdouDRt2n2GMTF_SPk/800x800/img?static=0' },
  { id: 4, name: 'NFT 4', image: '/img-proxy/api/v2/comments/676js0DzQ-3p1oAAAgr91ky7CEOy6MowmGkO75fOTEZoqRftljw6HiCdg04/photo/400x400/bedroom.jpeg' },
]

const CurrencyTypes = ["Soshi","AVAX","ETH"];
const chainMap = {
  "Soshi": { "chainId": "80952", "decimals": 18, "fixed": 2, "fontSize": "H0-Light", "networkName": "Soshi L1 Network" },
  "AVAX": { "chainId": "11155111", "decimals": 18, "fixed": 6, "fontSize": "H1-Regular", "networkName": "AVAX Network" },
  "ETH": { "chainId": "11155111", "decimals": 16, "fixed": 6, "fontSize": "H1-Regular", "networkName": "Ethereum Network" },
};
export default class AppWallet extends Component {
  @service router;
  @service account;
  @service dynamicDialogs;
  @service turnkey;

  @tracked userBalance = 0;
  @tracked userNonce = 0;
  @tracked selectedWalletTab = 'balance';
  @tracked selectedTransactionsTab = 'transactions';
  @tracked _userCurrencyType = CurrencyTypes[0];
  @tracked fixedDecimalNr = chainMap[this.userCurrencyType].fixed;
  @tracked decimals = chainMap[this.userCurrencyType].decimals;
  @tracked balanceFont = chainMap[this.userCurrencyType].fontSize;

  constructor() {
    super(...arguments);

    getConfigCatFlagPromise('web__is_wallet_enabled').then((value) => {
      if (!value) {
        this.router.transitionTo('app.myworld');
      }
    });
  }

  get mockNfts() {
    return nfts;
    // return [];
  }
  
  get userAddress() {
    return this.account.walletData.walletAddress;
  }

  get userCurrencyType() {
    return this._userCurrencyType;
  }

  get currencyTypes() {
    return CurrencyTypes;
  }

  get mockTransactions() {
    return transactions;
  }

  get hasUserEmail() {
    return isPresent(this.account.activeUser.primaryEmail);
  }

  get networkName() {
    return chainMap[this.userCurrencyType].networkName;
  }

  @action
  setWalletTab(tab) {
    this.selectedWalletTab = tab;
  }

  @action
  setTransactionsTab(tab) {
    this.selectedTransactionsTab = tab;
  }

  @action
  setSellPercentage(percentage) {
    console.log(`Set sell percentage to ${percentage}`);
  }

  @action
  async setupWallet() {
    this.turnkey.initializeTurnkey();
    this.fetchBalance();
    this.fetchNonce();
  }

  async fetchBalance() {
    const response = await WalletApi.getBalance({chainId: chainMap[this.userCurrencyType].chainId});
    this.userBalance = response.balance ?? 0;
    this.fixedDecimalNr = chainMap[this.userCurrencyType].fixed;
    this.decimals = chainMap[this.userCurrencyType].decimals;
    this.balanceFont = chainMap[this.userCurrencyType].fontSize;
  }

  async fetchNonce() {
    const response = await WalletApi.getNonce({chainId: chainMap[this.userCurrencyType].chainId});
    this.userNonce = response.nonce;
  }

  @action
  async addFunds() {
    const moonPay = await loadMoonPay();

    const widget = moonPay?.({
      flow: "buy",
      environment: "sandbox",
      params: {
        apiKey: "pk_test_U8LozN2EayORmOpU4kpGOwzgY4R6xvK",
        baseCurrencyCode: "usd",
        baseCurrencyAmount: "100",
        defaultCurrencyCode: "eth",
        walletAddress: this.userAddress,
        theme: "dark",
      },
      variant: "overlay",
      handlers: {
        onTransactionCompleted: async (props) => {
          later(this, () => {
            this.fetchBalance();
          }, 8000);
        },
      },
    });
    widget.show();
  }

  @action
  openWalletSendDialog() {
    this.dynamicDialogs.openDialog('wallet-send-dialog', {
      chainId: chainMap[this.userCurrencyType].chainId,
      nonce: this.userNonce,
      balance: this.userBalance,
    });
  }

  @action
  copyToClipBoard() {
    // navigator.clipboard.writeText(this.userAddress);
    MiscUtils.copyToClipboard(this.userAddress);
  }

  @action
  onUserCurrencyInput(event) {
    let value = event.target.value.replace(',', '.');
    if (value.length > 6) {
      value = value.slice(0, 6);
      event.target.value = value;
    }
    let num = parseFloat(value);
    if (!isNaN(num) && num >= 0.00001) {
      this.userCurrencyValue = num;
    } else if (value === '' || value === '0' || value === '0.' || value === '0,') {
      this.userCurrencyValue = '';
    }
  }

  formattedDate(date) {      
    return formatUTCDateToCustomString(date);
  }

  @action
  setUserCurrencyType(index) {
    this._userCurrencyType = CurrencyTypes[index];
    this.fetchBalance();
    this.fetchNonce();
  }

  @action
  navigateToSettings() {
    this.router.transitionTo('app.settings.account');
  }
}
